import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const CARTFUNNELRADIOOPTIONBLOCK_LEGACY_FIELD_ORDER = [
  "label",
  "value"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cartFunnelRadioOptionBlockDescriptor: _generatedCartFunnelRadioOptionBlockDescriptor,
  cartFunnelRadioOptionBlockBlocDefinition,
  cartFunnelRadioOptionBlockDashboardLayout,
  cartFunnelRadioOptionBlockConfig,
  cartFunnelRadioOptionBlockResolveConfig,
  cartFunnelRadioOptionBlockProperties,
} = doodBlockConfig(
  {
    name: "Cart funnel / Choices input / Option item",
    componentType: 'CartFunnelRadioOptionBlockComponent',
    category: 'cart',
    description: "Cart funnel / Choices input / Option item.",
    keywords: [],
    allowedIn: [
      { bloc: "CartFunnelRadioItemBlockComponent", slot: "options" },
    ],
    sharedFields: {}
  },

  () => ({
    label: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cart-funnel-radio-option.label.label",
        help: "pages.blocks.cart-funnel-radio-option.label.help",
      }
    }),
    value: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cart-funnel-radio-option.value.label",
        help: "pages.blocks.cart-funnel-radio-option.value.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.cart-funnel-radio-option.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cart-funnel-radio-option.fieldset.option.label",
            fields: ["label", "value"],
          },
        ],
      },
    ],
  })
);

export function cartFunnelRadioOptionBlockDescriptor(): IBlockDescriptor;
export function cartFunnelRadioOptionBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartFunnelRadioOptionBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartFunnelRadioOptionBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartFunnelRadioOptionBlockDescriptor, cartFunnelRadioOptionBlockProperties, fieldOrder);
}

export {
  cartFunnelRadioOptionBlockBlocDefinition,
  cartFunnelRadioOptionBlockDashboardLayout,
  cartFunnelRadioOptionBlockProperties,
  cartFunnelRadioOptionBlockConfig,
  cartFunnelRadioOptionBlockResolveConfig,
};

export type CartFunnelRadioOptionBlockConfig = typeof cartFunnelRadioOptionBlockConfig;
